import { AuthWithSSOService } from "../../../services/auth/service";
import { set, forget } from "@/common/helps/local-storage";

const state = () => ({
  processingSSO: false,
  errorSSO: {
    exist: false,
    msg: "",
  },
});

const mutations = {
  SET_ERROR(state, value = false) {
    state.error = value;
  },
  SET_PROCESSING_SSO(state, { value = true }) {
    state.processingSSO = value;
  },
  SET_ERRORS_SSO(state, { error = false, msg = "" }) {
    state.errorSSO.exist = error;
    state.errorSSO.msg = msg;
  },
};
const actions = {
  async authWithSSOAction({ commit }, { params = {} }) {
    commit("SET_PROCESSING_SSO", { value: true });
    commit("SET_ERRORS_SSO", { error: false });
    await AuthWithSSOService({ params })
      .then(({ result: { user, api_token } }) => {
        set("user", JSON.stringify(user));
        set("token", api_token);
        forget("token_sso");
        if (!user.privacy_policy) {
            window.location = "/terminos-y-condiciones";
        } else {
            window.location = "/";
        }
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          commit("SET_ERRORS_SSO", { error: true, msg: message });
        }
      )
      .finally(() => commit("SET_PROCESSING_SSO", { value: false }));
  },
};

const getters = {
  getErrorSSO: (state) => state.errorSSO,
  getProcessingSSO: (state) => state.processingSSO,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
